import { isBeforeToday } from '@components/workload/calendar/weekly/helpers';
import { parseISO } from 'date-fns';
import { ScheduleState } from './types';
import { rejectedStyles, styles } from './constants';
import { TaskColor } from '@config/colors/task';
import { ScheduleContact } from '@root/globalTypes';

export const getContactName = (contact?: ScheduleContact) => {
  if (!contact) return '';
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
  return contact.name || fullName;
};

export const getScheduleState = (startDate: string, status?: string): ScheduleState => {
  if (status === 'draft') return 'draft';
  if (!status || status === 'rejected') return 'withoutTeam';
  if (isBeforeToday(parseISO(startDate))) return 'past';
  if (status === 'approved') return 'accepted';
  return 'notAccepted';
};

const externalTaskVariants: Record<string, string> = {
  pending: 'text-neutral-300 border-neutral-200 bg-pending',
  approved: 'bg-white text-black',
  rejected: 'text-white bg-danger-500',
  inProgress: 'text-white bg-blue-500',
};

export const getExternalTaskStyle = (status?: string) => externalTaskVariants[status || 'pending'];

export const getHotSeatScheduleStyle = (
  color: string,
  foremanId?: string,
  status?: string,
): string => {
  const key = (color || 'default') as TaskColor | 'default';
  if (status === 'draft') return styles[key].draft.regular;
  if (!foremanId) return styles[key].withoutTeam.regular;
  if (status === 'rejected') return rejectedStyles;
  if (status === 'approved') return styles[key].approved.regular;
  return styles[key].notAccepted.regular;
};
